import { api } from '@services';

interface ICreateTaskComment {
  taskId: string;
  comment: string;
}

const createTaskComment = async ({
  comment,
  taskId,
}: ICreateTaskComment): Promise<void> => {
  await api.post(`/tasks/${taskId}/comments`, { comment });
};

export { createTaskComment };
